var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBMlogoClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1241 27.1796L27.5039 21.9901L30.0323 16.591C30.2592 16.0981 30.3588 15.5559 30.3217 15.0144C30.2847 14.4729 30.1122 13.9494 29.8202 13.4921C29.5283 13.0349 29.1262 12.6586 28.6509 12.3978C28.1757 12.1371 27.6426 12.0003 27.1008 12H20.229C19.3726 12 18.5513 12.3408 17.9458 12.9474C17.3402 13.554 17 14.3768 17 15.2347V36L22.0581 31.9792H28.2973C28.859 31.9791 29.4109 31.8322 29.8986 31.5531C30.3863 31.274 30.7929 30.8723 31.0784 30.3878C31.3638 29.9032 31.5182 29.3524 31.5263 28.7898C31.5344 28.2272 31.396 27.6723 31.1246 27.1796H31.1241ZM27.6124 28.3114H20.661V15.6669H26.4246L23.4715 21.9896L27.6124 28.3114Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBMlogoClear);
export default __webpack_public_path__ + "static/media/BMlogo-clear.849f2b1d64ebddce6e820061b15871fc.svg";
export { ForwardRef as ReactComponent };